<div class="container-fluid">
  <div class="card overflow-x-hidden">
    <div class="card-header nocollapse">
      Slider Question
    </div>
    <div [hidden]="folderId == -1">
      <div class="bg-info p-1 mb-3">
        <div class="row">
          <div class="col-md-10">
            <span class="text-white pt-2" style="font-size:18px; display:inline-block"><b>Folder Name : </b>{{ folderName }}</span>
          </div>
          <div class="col-md-2 py-1">
            <button type="button" class="btn btn-primary btn-action" (click)="BackToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-arrow-left"></i> Back to Section</button>
            <button type="button" class="btn btn-primary btn-action mb-0" (click)="BackUrl()"><i class="fa fa-home"></i> Home</button>
          </div>
        </div>
      </div>
    </div>

    <div id="messageContainer" class="card-header nocollapse bg-info col-md-12 msg-container" style="display:none;">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <span id="message"></span>
    </div>

    <div class="card-body">
      <form [formGroup]="sliderForm" class="col-md-12">

        <!-- Custom Accordion Implementation -->
        <div class="nav-item dropdown p-2">
          <div class="card mb-2">
            <div class="card-header btn-primary" (click)="showTitlePanel = !showTitlePanel" style="cursor:pointer;">
              <b>Question Title</b>
              <span class="float-end"><i class="fa" [ngClass]="{'fa-chevron-down': showTitlePanel, 'fa-chevron-right': !showTitlePanel}"></i></span>
            </div>
            <div class="collapse" [ngClass]="{'show': showTitlePanel}">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-2">
                    <label data-required class="form-label" for="description">Title</label>
                  </div>
                  <div class="col-md-10">
                    <textarea class="form-control" style="width:100%" rows="10" id="description" name="description" formControlName="description" placeholder="Type Question" #description> </textarea>
                  </div>
                </div>
                <br />
                <div class="row">
                  <label class="form-label col-md-2" for="questionCategoryId"> Category</label>
                  <div class="col-md-3">
                    <select name="questionCategoryId" id="questionCategoryId" formControlName="questionCategoryId" class="form-control" (change)="onCategoryChange()">
                      <option value="" selected>--Select--</option>
                      <option *ngFor="let item of questionCategoryList" [ngValue]="item?.questionCategoryId" [selected]="questionCategoryId==item?.questionCategoryId">
                        {{item.questionCategoryName}}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-auto">
                    <button type="button" class="btn btn-primary btn-action"
                            (click)="openCategoryModal()">
                      <i class="fa fa-plus"></i> Create Category
                    </button>
                  </div>
                  <label class="col-md-auto form-label" for="shortName">Short Name</label>
                  <div class="col-md-3">
                    <input class="form-control" type="text" id="shortName" name="shortName" formControlName="shortName" placeholder="Short Name" />
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="card mb-2">
            <div class="card-header btn-primary" (click)="showSchemaPanel = !showSchemaPanel" style="cursor:pointer;">
              <b>Grading Schema</b>
              <span class="float-end"><i class="fa" [ngClass]="{'fa-chevron-down': showSchemaPanel, 'fa-chevron-right': !showSchemaPanel}"></i></span>
            </div>
            <div class="collapse" [ngClass]="{'show': showSchemaPanel}">
              <div class="card-body">
                <div class="row mb-2">
                  <div class="col-md-10 d-flex justify-content-start">
                    <button type="button" class="btn btn-primary btn-action" (click)="openCreateSchemaModal()"><i class="fa fa-plus"></i> Create Grading Schema</button>
                  </div>
                </div>
                <div class="row">
                  <label data-required class="form-label col-md-2" for="serviceLineId">Grading Schema Name</label>
                  <div class="col-md-3">
                    <select name="schemaId" id="schemaId" formControlName="schemaId" class="form-control" (change)="onSchemaChange()">
                      <option value="" selected>--Select--</option>
                      <option *ngFor="let item of gradingSchemaList" [ngValue]="item?.schemaId" [selected]="schemaId==item?.schemaId">
                        {{item.schemaName}}
                      </option>
                    </select>
                  </div>
                  <label class="col-md-auto form-label" for="defRangeValue">Default</label>
                  <div class="col-md-3"><input class="form-control" type="text" id="defRangeValue" name="defRangeValue" formControlName="defRangeValue" placeholder="Default" /></div>
                </div>
                <br />
                <table style="width:100%;">
                  <tr>
                    <td>
                      <isg-grid [rowData]="schemaDetailList"
                                [columnDefs]="columnDefs"
                                [config]="schemaDetailGridConfig"
                                (gridReady)="onQuestionGridReady($event)">
                      </isg-grid>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <div class="col-md-12">
            <div class="text-center">
              <button type="submit" class="btn btn-primary btn-action" [disabled]="!sliderForm.valid" (click)="saveSliderQuestion()"><i class="fa fa-save"></i> Save</button>
              <button type="submit" class="btn btn-secondary btn-action" (click)="BackUrl()" [hidden]="redirectedSectionId!=null || redirectedSurveyId!=null"><i class="fa fa-times"></i> Cancel</button>
              <button type="button" class="btn btn-secondary btn-action" (click)="BackToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-times"></i> Cancel</button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <ng-template #createEditGSchema let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Select Grading Schema </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="ResetValueSchemaPopup(); modal.dismiss()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="createEditSchemaForm" #f="ngForm">
          <div class="row">
            <label data-required class="col-md-2 form-control-label" for="schemaName">Grading Schema Name</label>
            <div class="col-md-3"><input class="form-control" type="text" id="schemaName" name="schemaName" formControlName="schemaName" placeholder="Grading Schema Name" /></div>
            <label class="col-md-auto form-control-label" for="weightage">Weightage</label>
            <div class="col-md-3"><input class="form-control" type="text" id="weightage" name="weightage" formControlName="weightage" placeholder="Weightage" /></div>
          </div>
          <div class="row">
            <div class="form-group">
              <label data-required class="col-md-6 form-control-label" for="minRangeValue">Min</label>
              <input class="col-md-6 form-control" type="text" id="minRangeValue" name="minRangeValue" formControlName="minRangeValue" placeholder="Min" />
            </div>
            <div class="form-group">
              <label data-required class="col-md-6 form-control-label" for="maxRangeValue">Max</label>
              <input class="col-md-6 form-control" type="text" id="maxRangeValue" name="maxRangeValue" formControlName="maxRangeValue" placeholder="Max" />
            </div>
            <div class="form-group">
              <label data-required class="col-md-6 form-control-label" for="rangeDescription">Description</label>
              <input class="col-md-6 form-control" type="text" id="rangeDescription" name="rangeDescription" formControlName="rangeDescription" placeholder="Description" />
            </div>
            <div class="col-md-4">
              <button type="button" class="btn btn-primary btn-action" [disabled]="!createEditSchemaForm.valid" (click)="AddUpdateGradingDetail($event)"><i class="fa fa-map-o"></i> Add/Update</button>
            </div>
          </div>
          <div class="form-group">
            <isg-grid [rowData]="popupSchemaList"
                      [columnDefs]="colDefsSchemaDetails"
                      [config]="popupSchemaGridConfig"
                      (rowSelected)="onRowSelected($event)"
                      (gridReady)="onSchemaDetailsGridReady($event)">
            </isg-grid>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-modal" (click)="ResetValueSchemaPopup(); modal.dismiss()"><i class="fa fa-times"></i> Close</button>
        <button type="button" class="btn btn-primary btn-modal" (click)="saveSchemaDetails(); modal.close()"><i class="fa fa-save"></i> Save</button>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #deleteConfirmation let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    <button type="button" class="btn btn-danger btn-modal" (click)="DeleteGradingDetail(); modal.close()"><i class="fa fa-trash"></i> Delete</button>
  </div>
</ng-template>
<ng-template #CreateUpdateQsCategoryModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Create Category</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="ResetQuesCategoryForm(); modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="quesCategoryForm" #f="ngForm">
      <div class="row align-items-center">
        <label data-required class="form-control-label col-md-4" for="quesCategoryName">Category</label>
        <div class="col-md-8">
          <input class="form-control" type="text" id="quesCategoryName" name="quesCategoryName" formControlName="quesCategoryName" placeholder="Category" />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="ResetQuesCategoryForm(); modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    <button type="button" class="btn btn-primary btn-modal" [disabled]="!quesCategoryForm.valid" (click)="AddQuesCategory(); modal.close()"><i class="fa fa-save"></i> Save</button>
  </div>
</ng-template>









